module.exports = __webpack_public_path__ + "img/Canada.b53ac86d.svg";